import { CustomImage, CustomPageHeader, Text, useText } from '@src/components';
import '@src/styles/companyInformation/creditcards/creditcards.scss';
import { Alert, Button, Checkbox, Collapse, Tooltip } from 'antd';
import iconInfo from '@src/assets/icons/icon-info.svg';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import masterCardLogo from '@src/assets/images/cardOrders/mastercard-logo.svg';
import po from '@src/assets/icons/ticketcar/4.svg';
import ticketrestaurant from '@src/assets/images/login/logo-ticketrestaurant.svg';
import trash from '@src/assets/icons/trash.svg';
import cardSlash from '@src/assets/icons/icon-card-slash.svg';
import warningLogo from '@src/assets/icons/icon-modal-warning.svg';
import ProvisionDateModal from './ProvisionDateModal';
import AutomaticPaymentInstructionModal from './AutomaticPaymentInstructionModal';
import CardDeleteModal from './CardDeleteModal';
import { useDispatch, useSelector } from 'react-redux';
import { getCardWithVouList } from '@src/store/slice/mobilExpressSlice';
import { bankCodeIcon, cardTypeIcon } from '@src/utils/utils';
import PropTypes from 'prop-types';

const { Panel } = Collapse;

const CreditCards = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { vouIdList } = useSelector((state) => state?.menus);
  const [isData, setIsData] = useState(false);
  const [creditCardList, setCreditCardList] = useState([]);
  const [isFavoriteCard, setIsFavoriteCard] = useState(true);
  const [favoriteCard, setFavoriteCard] = useState([]);
  const [allCards, setAllCards] = useState([]);
  const [provisionDateModalVisible, setProvisionDateModalVisible] = useState(false);
  const [automaticPaymentModalVisible, setAutomaticPaymentModalVisible] = useState(false);
  const [cardDeleteModalVisible, setCardDeleteModalVisible] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [checkedList, setCheckedList] = useState([]);
  const [activePanel, setActivePanel] = useState(null);
  const isCouldBeActive = useRef(1);

  const companyInformation2 = useText('companyInformation2');
  const removeFromAutomaticPaymentText = useText('removeFromAutomaticPayment');
  const delete2Text = useText('delete2');

  const hasActiveFlag = useCallback((array) => {
    setAllCards(favoriteCardGroupData(array));
    const filteredData = favoriteCardGroupData(
      array?.filter((a) => !(a.unlimited_Contract && a.default_Flag)),
    );
    setFavoriteCard(
      favoriteCardGroupData(array?.filter((a) => a.unlimited_Contract && a.default_Flag)),
    );
    setIsFavoriteCard(array?.filter((a) => a.unlimited_Contract && a.default_Flag)?.length);
    setCreditCardList(filteredData);
  }, []);

  const handlePanelChange = (key) => {
    setCheckedList({ id: [], maskedCardNumber: null });
    setActivePanel((prevKey) => (prevKey === key ? null : key));
  };

  const favoriteCardGroupData = (data) => {
    const groupedData = groupData(data);

    const result = Object.keys(groupedData).map((maskedCardNumber) => ({
      maskedCardNumber,
      ...groupedData[maskedCardNumber],
    }));

    return result;
  };

  const groupData = (data) => {
    if (!data || data.length === 0) {
      return {};
    }

    return data.reduce((acc, entry) => {
      const { maskedCardNumber, vouId, ...rest } = entry;

      if (!acc[maskedCardNumber]) {
        acc[maskedCardNumber] = { ...rest, vouIds: [] };
      }

      acc[maskedCardNumber].vouIds.push(vouId);

      return acc;
    }, {});
  };

  const init = async () => {
    const array = await changeActiveFlag();
    setIsData(array?.length > 0);
  };

  useEffect(() => {
    init();
  }, [dispatch, selectedCustomer]);

  const changeActiveFlag = async () => {
    const action = await dispatch(getCardWithVouList({ notVoudId: true }));
    if (getCardWithVouList.fulfilled.match(action)) {
      const array = action.payload.data.cardList;
      hasActiveFlag(array);
      return array;
    }
    return null;
  };
  const handleChange = useCallback(async () => {
    await changeActiveFlag();
  }, []);

  const handleModalSetActiveCard = (token, type) => {
    isCouldBeActive.current = type;
    const active = allCards.find((cr) => cr.cardToken === token);
    setActiveCard(active);
  };
  const handleCardDeleteModal = (token, type) => {
    handleModalSetActiveCard(token, type);
    setCardDeleteModalVisible(true);
  };

  const handleAutomaticPaymentModal = (token, type) => {
    handleModalSetActiveCard(token, type);
    setAutomaticPaymentModalVisible(true);
  };
  const options = [
    vouIdList?.includes(1) && { label: 'Ticket Restaurant', value: 1 },
    vouIdList?.includes(94) && { label: 'Ticket Gift', value: 94 },
    vouIdList?.includes(11) && { label: 'Ticket Market', value: 11 },
    vouIdList?.includes(4) && { label: 'Petrol Ofisi', value: 4 },
  ].filter(Boolean);
  return (
    <CustomPageHeader
      data-testid="delivery-adresses"
      title={<Text t="creditCardList" />}
      showBreadCrumb
      showHelpButton
      routes={[companyInformation2]}
    >
      {!isData ? (
        <div className="empty-credit-card-content">
          <Alert
            message={
              <div className="alert-message-contain">
                <CustomImage src={iconInfo} />{' '}
                <div className="alert-message-content">
                  <p>
                    <Text t="youDoNotHaveAnyRegisteredCreditCards" />
                  </p>
                </div>
              </div>
            }
            banner
            showIcon={false}
            className="custom-alert-warning"
          />

          <Button
            id="companyInformation-creditCards-main-add-credit-card-btn"
            className="add-credit-card-btn"
            onClick={() => history.push('/company-information/credit-cards/new-credit-card')}
          >
            <Text t="addCreditCard" />
          </Button>
        </div>
      ) : (
        <div className="credit-card-list-content">
          <div className="product-list-content">
            <Alert
              message={
                <div className="alert-message-contain">
                  <CustomImage src={iconInfo} />{' '}
                  <div className="alert-message-content">
                    <p>
                      <Text t="whatIsAutomaticPaymentInstruction" />
                    </p>
                    <div className="info-list">
                      <span className="info-text-item">
                        <Text t="theCardForWhichYouHaveGivenAn" />
                      </span>
                      <span className="info-text-item">
                        {' '}
                        <Text t="forYourSelectedEdenredProductsOurSystemWill" />
                      </span>
                    </div>
                  </div>
                </div>
              }
              banner
              showIcon={false}
              className="custom-alert-info"
            />

            {!isFavoriteCard ? (
              <div className="empty-favorite-credit-card">
                <CustomImage src={warningLogo} />
                <b>
                  <Text t="youDoNotHaveACardSelectedFor" />
                </b>
              </div>
            ) : (
              <div className="favorite-credit-card-label">
                <b>
                  <Text t="myCardsWithAutomaticPaymentInstruction" />
                </b>
              </div>
            )}
            <div className="favorite-credit-card-list">
              {isFavoriteCard > 0 &&
                favoriteCard.map((fCard, index) => {
                  const bankIcon = bankCodeIcon(fCard?.bankCode);
                  return (
                    <div key={fCard.maskedCardNumber + index} className="favorite-credit-card">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="credit-card-item">
                          <CustomImage className="bank-card-logo" src={bankIcon} />
                          <div className="card-number">{fCard.maskedCardNumber}</div>
                          <div className="card-info">
                            <CustomImage className="card-type-logo" src={masterCardLogo} />
                          </div>
                        </div>
                        <div className="credit-card-left-border">
                          <Tooltip title={removeFromAutomaticPaymentText} placement="top">
                            <button
                              onClick={() => handleAutomaticPaymentModal(fCard?.cardToken, 0)}
                            >
                              <CustomImage src={cardSlash} />
                            </button>
                          </Tooltip>
                          <Tooltip title={delete2Text} placement="top">
                            <button onClick={() => handleCardDeleteModal(fCard?.cardToken, 0)}>
                              <CustomImage style={{ width: '16px', height: '16px' }} src={trash} />
                            </button>
                          </Tooltip>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          marginTop: '16px',
                          gap: '8px',
                          height: '24px',
                        }}
                      >
                        {fCard?.vouIds?.includes(1) && <CustomImage src={ticketrestaurant} />}
                        {fCard?.vouIds?.includes(4) && <CustomImage src={po} />}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          {creditCardList.length > 0 && (
            <div className="saved-credit-card-list-content">
              <span className="saved-card-label-text">
                <b>
                  <Text t="myRegisteredCards" />
                </b>
              </span>

              <div className="saved-credit-card-list">
                {creditCardList.map((creditCard, index) => {
                  const bankIcon = bankCodeIcon(creditCard?.bankCode);
                  const cardIcon = cardTypeIcon(creditCard?.cardType);
                  return (
                    <div className="card-list-item" key={creditCard?.maskedCardNumber + index}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <div className="credit-card-item">
                          <CustomImage className="bank-card-logo" src={bankIcon} />
                          <div className="card-number">{creditCard?.maskedCardNumber}</div>
                          <div className="card-info">
                            <CustomImage className="card-type-logo" src={cardIcon} />
                          </div>
                        </div>
                        <Tooltip title={delete2Text} placement="top">
                          <button
                            onClick={() => handleCardDeleteModal(creditCard?.cardToken, 1)}
                            className="credit-card-left-border"
                          >
                            <CustomImage style={{ width: '16px', height: '16px' }} src={trash} />
                          </button>
                        </Tooltip>
                      </div>

                      <div>
                        <Collapse
                          expandIconPosition="right"
                          ghost
                          bordered={false}
                          accordion
                          activeKey={activePanel}
                          onChange={handlePanelChange}
                        >
                          <Panel
                            header={
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#162056',
                                  fontFamily: 'UbuntuMedium',
                                  fontWeight: '500',
                                }}
                              >
                                <Text t="addToAutomaticPayment" />
                              </div>
                            }
                            key={creditCard?.maskedCardNumber + index}
                          >
                            <Checkbox.Group
                              key={creditCard?.maskedCardNumber + index}
                              className="checkbox-group-list"
                              options={options}
                              value={checkedList?.id || []}
                              onChange={(list) => {
                                setCheckedList({
                                  id: list,
                                  maskedCardNumber: creditCard?.maskedCardNumber,
                                });
                              }}
                            />
                            <button
                              type="button"
                              className="custom-checkbox-button"
                              onClick={() => handleAutomaticPaymentModal(creditCard?.cardToken, 1)}
                              disabled={
                                checkedList?.id?.length === 0 ||
                                checkedList?.maskedCardNumber !== creditCard?.maskedCardNumber
                              }
                            >
                              {' '}
                              <Text t="add" />{' '}
                            </button>
                          </Panel>
                        </Collapse>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <Button
            id="companyInformation-add-new-credit-card-btn"
            className="add-new-credit-card-btn"
            onClick={() => history.push('/company-information/credit-cards/new-credit-card')}
          >
            <Text t="addNewCreditCard" />
          </Button>
        </div>
      )}

      <ProvisionDateModal
        modalVisible={provisionDateModalVisible}
        handleModalVisible={function () {
          setProvisionDateModalVisible(false);
          setActiveCard(null);
        }}
        activeCard={activeCard}
        init={handleChange}
      />

      <AutomaticPaymentInstructionModal
        modalVisible={automaticPaymentModalVisible}
        handleModalVisible={function (value) {
          setActiveCard(null);
          setAutomaticPaymentModalVisible(value);
        }}
        activeCard={activeCard}
        init={handleChange}
        type={isCouldBeActive?.current}
        checkedList={isCouldBeActive?.current === 1 ? checkedList?.id : activeCard?.vouIds}
        setCheckedList={setCheckedList}
        setActivePanel={setActivePanel}
      />

      <CardDeleteModal
        modalVisible={cardDeleteModalVisible}
        handleModalVisible={setCardDeleteModalVisible}
        activeCard={activeCard}
        init={handleChange}
        type={isCouldBeActive?.current}
      />
    </CustomPageHeader>
  );
};

export default CreditCards;

CreditCards.propTypes = {
  selectedCustomer: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};
